export const playwright_search_bar_input = "search.bar.input";
export const playwright_page_title = "page.title";

// Drawers and Modals
export const playwright_presented_drawer_parent = "presented.drawer.parent";
export const playwright_presented_modal_parent = "presented.modal.parent";

// Cards and rows
export const playwright_action_menu_button = "action.menu.button";
